import Q from 'q';
import _ from 'underscore';

import Group from 'bundles/groups/models/Group';
import GroupSetting from 'bundles/groups/models/GroupSetting';
import GroupMembershipAPIUtils from 'bundles/groups/utils/GroupMembershipAPIUtils';

/**
 * @param {Fluxible.ActionContext} actionContext
 * @param {object} options
 * @param {string} options.courseId
 * @return {Promise}
 */
export const loadUserGroupsForCourse = (
  actionContext: $TSFixMe,
  { courseId, userId }: { courseId: string; userId: string }
) => {
  if (actionContext.getStore('GroupSettingStore').hasLoaded()) {
    return Q();
  }

  return GroupMembershipAPIUtils.myCourseGroupsWithSettings(userId, courseId)
    .then((response: $TSFixMe) => {
      const groupSettings = _(response.linked['groupSettings.v1']).map((setting) => new GroupSetting(setting));
      const groups = response.linked['groups.v1'].map((group: $TSFixMe) => new Group(group));
      const groupMemberships = response.elements;
      actionContext.dispatch('LOADED_COURSE_GROUPS', {
        groups,
        groupSettings,
        groupMemberships,
      });
    })
    .fail((err: $TSFixMe) => {
      actionContext.dispatch('LOADED_COURSE_GROUPS', {});
    });
};

/**
 * @param {Fluxible.ActionContext} actionContext
 * @param {object} options
 * @param {string} options.courseId
 * @param {string} options.userId
 * @param {string} options.sessionId
 * @return {Promise}
 */
export const loadUserSessionGroupForCourse = (
  actionContext: $TSFixMe,
  { courseId, userId, sessionId }: { courseId: string; userId: string; sessionId: string }
) => {
  if (actionContext.getStore('GroupSettingStore').hasSessionGroupLoaded()) {
    return Q();
  }

  return GroupMembershipAPIUtils.getCourseSessionGroup(userId, courseId, sessionId)
    .then((response: $TSFixMe) => {
      const sessionGroup = response.elements[0];
      actionContext.dispatch('LOADED_SESSION_GROUP', {
        sessionGroup,
      });
    })
    .fail((err: $TSFixMe) => {
      actionContext.dispatch('LOADED_SESSION_GROUP', {});
    });
};
